import { PwaUtils } from '@ixigo/pwa';
import { isForeignEnvironment } from './client';

type LocationResult = {
	latitude: number;
	longitude: number;
};

/**
 * Get location using PWA native bridge
 * Falls back to geolocation API if native bridge is not available
 */
export async function getPwaLocation(): Promise<
	{ lat: number; lng: number } | undefined
> {
	if (!isForeignEnvironment()) {
		return undefined;
	}

	if (!window.IXIGO) {
		// Required by PwaUtils.getUserLocation
		window.IXIGO = {
			HELPER: {
				// biome-ignore lint/suspicious/noExplicitAny: required by PWA Utils API signature
				triggerEvent: (_window: Window, eventName: string, data: any) => {
					let event: CustomEvent;
					if (window.CustomEvent) {
						event = new CustomEvent(eventName, { detail: data });
					} else {
						event = document.createEvent('CustomEvent');
						event.initCustomEvent(eventName, true, true, data);
					}
					_window.dispatchEvent(event);
				},
				geoLocationSuccessCallback: null,
				geoLocationFailureCallback: null,
			},
		};
	}

	try {
		// Tries to fetch location from host native app or fallbacks to geolocation api
		const location = (await PwaUtils.getUserLocation()) as
			| LocationResult
			| undefined;
		if (
			location &&
			typeof location.latitude === 'number' &&
			typeof location.longitude === 'number'
		) {
			// Convert from latitude/longitude to lat/lng format
			return {
				lat: location.latitude,
				lng: location.longitude,
			};
		}
		return undefined;
	} catch {
		return undefined;
	}
}
